import React from "react";
import { calculateDistance, yCursorPlacement, rotation } from "./function";
import { Line, Text, Circle } from "react-konva";
import { useSelector } from "react-redux";

export default function CursorLine({cursorDistance, points}) {
 
  const roofInfo = useSelector((state) => state.roof)
  const gridInfo = useSelector((state) => state.grid)
  const view = roofInfo.value.mapOption.mapTypeId;

  return (
    <React.Fragment>
      {points.length > 0 && (
        <Line
          points={[
            points[points.length - 1].x,
            points[points.length - 1].y,
            cursorDistance.x,
            cursorDistance.y,
          ]}
          stroke="black"
        />
      )}
      {cursorDistance && <Circle x={cursorDistance.x} y={cursorDistance.y} radius={5} fill="red" dragabble/>}
      {points.length > 0 && (
        <Text
          x={((cursorDistance.x + points[points.length - 1].x) / 2)}
          y={yCursorPlacement(cursorDistance, points[points.length - 1])}
          text={`${calculateDistance(
            cursorDistance,
            points[points.length - 1], roofInfo, gridInfo
          )}`}
          rotation={rotation(cursorDistance, points[points.length - 1])}
          fontFamily="italic"
          fontSize={14}
          fill={view === "satellite" ? "white" : "red"}
          strokeWidth={1}
        />
      )}
      {points.length > 0 && (
        <Text
          x={cursorDistance.x + 8}
          y={cursorDistance.y + 8}
          text={`${Rotation(cursorDistance, points[points.length - 1])}°`}
          fontFamily="italic"
          fontSize={12}
          fill={view === "satellite" ? "white" : "red"}
          strokeWidth={1}
        />
      )}
    </React.Fragment>
  );
}

function Rotation(point1, point2) {
  const slope = (point2.y - point1.y) / (point2.x - point1.x);
  const angleInRadians = Math.atan(slope);
  let angleInDegrees = Number(((angleInRadians * 180) / Math.PI).toFixed());

  if(angleInDegrees < 0){
    angleInDegrees = -(angleInDegrees)
  }else if(point2.y === point1.y){
    angleInDegrees = 0
  }
  return angleInDegrees;
}